import React, { useEffect } from 'react'
import { achivements } from '../data'
import './Work.css'
import Aos from 'aos'
import "aos/dist/aos.css"

export const Work = () => {
    useEffect(() => {
        Aos.init(({}))
    })
    return (
        <div className="work" id="work">
            <p >
                ACHIVEMENTS
            </p>
            <div>
                {
                    achivements.map(data => {
                        return (
                            <div data-aos="zoom-in-left" data-aos-duration="10000" className="card1" key={data.name}>
                                <nav className="_green"></nav>
                                <h3 className="title1" style={{ color: "black", fontWeight: "600" }}>{data.name}</h3>
                                <section className="info1">{data.text}</section>
                                <div>
                                    <img className="work-photo" alt="" src={data.photo}></img>
                                </div>
                                <div className="done-on1">
                                    {data.date}
                                </div>
                                <img alt="" src="https://img.icons8.com/ios-filled/30/65f4ad/long-arrow-right.png" />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
